import React, { useState } from 'react';
import RenderLandingPageSectionHero from './RenderLandingPageSectionHero';
import css from './SectionHero.module.css';
import { FormattedMessage, useIntl } from 'react-intl';
import mainImage from './Assets/leftLargeImage.jpeg';
import topRightImage from './Assets/topRightImage.jpeg';
import bottomRightImage from './Assets/bottomRightImage.jpg';
import { Modal } from '../../../../components';

/**
 * @typedef {Object} FieldComponentConfig
 * @property {ReactNode} component
 * @property {Function} pickValidProps
 */

/**
 * Section component for a website's hero section
 * The Section Hero doesn't have any Blocks by default, all the configurations are made in the Section Hero settings
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {Object} props.defaultClasses
 * @param {string} props.defaultClasses.sectionDetails
 * @param {string} props.defaultClasses.title
 * @param {string} props.defaultClasses.description
 * @param {string} props.defaultClasses.ctaButton
 * @param {string} props.sectionId id of the section
 * @param {'hero'} props.sectionType
 * @param {Object?} props.title
 * @param {Object?} props.description
 * @param {Object?} props.appearance
 * @param {Object?} props.callToAction
 * @param {Object} props.options extra options for the section component (e.g. custom fieldComponents)
 * @param {Object<string,FieldComponentConfig>?} props.options.fieldComponents custom fields
 * @param {Object} props.appConfig your app configuration object
 * @param {Function} props.handleSearch your function to process the search
 * @returns {JSX.Element} Section for article content
 */
const SectionHero = props => {
  const { heroSearchRef } = props;

  const intl = useIntl();

  return (
    <div className={css.heroSearchContainer}>
      <div className={css.heroSearchFormAnchor} ref={heroSearchRef}>
        <RenderLandingPageSectionHero />
      </div>
      <div className={css.gallaryDesktopWrapper}>
        <div className={css.gallaryDesktopSec}>
          <div className={css.itemWrapper}>
            <div className={css.formHead}>
              <h1>
                <FormattedMessage id="SectionHero.headline" />
              </h1>
            </div>
            <img
              src="https://res.cloudinary.com/dprwdukwm/image/upload/v1763535314/leftLargeImage-min_1_pcy0eq.jpg"
              alt={intl.formatMessage({
                id: 'SectionHero.imageAlt1',
              })}
            />
          </div>
          <div className={css.itemWrapper}>
            <img
              src="https://res.cloudinary.com/dprwdukwm/image/upload/v1763450344/topRightImage_xqiscl.jpg"
              alt={intl.formatMessage({
                id: 'SectionHero.imageAlt2',
              })}
            />
          </div>
          <div className={css.itemWrapper}>
            <img
              src="https://res.cloudinary.com/dprwdukwm/image/upload/v1763450335/bottomRightImage_dvdydx.jpg"
              alt={intl.formatMessage({
                id: 'SectionHero.imageAlt3',
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionHero;
